module.exports = __webpack_public_path__ + "static/media/StudentPictureGroup.3e11666f.svg";